import { ProductTypeEnum } from '../../../models/PricebookData';
import { SummedReport, PricebookReport } from '../../../models/ReportData';
import { toPascalCase } from '../../../helpers/utilityFunctions';

type AccountType = 'Subscription' | 'Free';

const paidProducts: ProductTypeEnum[] = [
  ProductTypeEnum.GuidedChoice,
  ProductTypeEnum.Nickels,
  ProductTypeEnum.NickelsU,
  ProductTypeEnum.Bundled,
];

const excludedChartProductTypes: string[] = [ProductTypeEnum.Total, ProductTypeEnum.Subscription];

const getProductTypeKey = (productType: ProductTypeEnum | undefined): string => {
  if (!productType) return '';

  if (productType === ProductTypeEnum.Nickels || productType === ProductTypeEnum.NickelsU) {
    return '3Nickels';
  }

  return toPascalCase(productType);
};

const isPaidProduct = (productType: ProductTypeEnum | undefined): boolean => {
  if (!productType) return false;
  return paidProducts.includes(productType);
};

const getAccountType = (productType: ProductTypeEnum | undefined): AccountType => {
  return isPaidProduct(productType) ? 'Subscription' : 'Free';
};

const findPricebookReportsByType = (
  summedReport: SummedReport | null,
  productTypes?: string | string[],
): PricebookReport[] => {
  if (!summedReport) return [];

  const allPricebookReports =
    'pricebookReports' in summedReport && Array.isArray(summedReport.pricebookReports)
      ? summedReport.pricebookReports
      : [];

  if (!productTypes) {
    return allPricebookReports;
  }

  const productTypesArray = Array.isArray(productTypes) ? productTypes : [productTypes];

  return allPricebookReports.filter(report => {
    const reportProductType = report.productType as string;
    return productTypesArray.some(
      type => type.toString().toLowerCase() === reportProductType?.toLowerCase(),
    );
  });
};

const findChartablePricebookReports = (summedReport: SummedReport | null): PricebookReport[] => {
  return findPricebookReportsByType(summedReport).filter(
    report => !excludedChartProductTypes.includes(report?.productType as string),
  );
};

export {
  type AccountType,
  paidProducts,
  getProductTypeKey,
  isPaidProduct,
  getAccountType,
  findPricebookReportsByType,
  findChartablePricebookReports,
};
